<template>
  <div class="py-8 mt-8 flex flex-col items-center gap-4 text-center">
    <div
      class="w-full max-w-[720px] rounded-lg border-2 border-[#FF0000] bg-black/40 px-4 md:px-8 py-6 flex flex-col gap-3"
    >
      <h2 class="text-[#FF0000] font-russo text-xl md:text-2xl">
        <span aria-hidden="true">✓ </span>{{ heading }}
      </h2>
      <p class="text-[16px] md:text-[18px] text-white">{{ body }}</p>
      <picture class="contents">
        <source :srcset="webp" type="image/webp" />
        <img
          decoding="async"
          loading="lazy"
          :width="width"
          :height="height"
          :src="png"
          class="m-auto rounded border border-[#444] max-w-full h-auto"
          :alt="alt"
        />
      </picture>
      <p
        v-if="mapLangs"
        class="text-[14px] md:text-[15px] text-[#cfcfcf] border-t border-[#555] pt-4"
      >
        {{ mapLangs }}
      </p>
    </div>
  </div>
</template>

<script>
// Localized "the app is available in your language" callout, shown on the
// pillar pages whose language the Rally Navigator desktop UI supports.
export default {
  name: 'LanguageSupport',
  props: {
    heading: { type: String, required: true },
    body: { type: String, required: true },
    img: { type: String, required: true },
    width: { type: [Number, String], default: 640 },
    height: { type: [Number, String], default: 360 },
    alt: { type: String, default: '' },
    mapLangs: { type: String, default: '' },
  },
  computed: {
    webp() {
      return `/images/system-language/${this.img}.webp`;
    },
    png() {
      return `/images/system-language/${this.img}.png`;
    },
  },
};
</script>

<style scoped></style>
